import { render, staticRenderFns } from "./NXTRouteReceiverSelector.vue?vue&type=template&id=e51ac4e8&scoped=true"
import script from "./NXTRouteReceiverSelector.vue?vue&type=script&lang=js"
export * from "./NXTRouteReceiverSelector.vue?vue&type=script&lang=js"
import style0 from "./NXTRouteReceiverSelector.vue?vue&type=style&index=0&id=e51ac4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51ac4e8",
  null
  
)

export default component.exports